import React from "react";
import Location from "@/components/Card/Location";
import Rating from "@/components/Card/Rating";
import Amenities from "@/components/Card/Amenities";
import Tag from "../Card/Tag";
import Image from "next/image";
import FavoriteButton from "../Card/FavoriteButton";

const DetailHeader = ({ villa }) => {
  return (
    <div className="flex flex-col gap-3 mb-3 xsm:mb-0">
      <div className="flex flex-wrap items-center gap-3 xsm:gap-6">
        <Location location={villa.destination} />
        <div className="flex flex-wrap items-center gap-1.5">
          <div className="flex items-center gap-x-1.5">
            {villa?.ribbon && <Tag text={villa?.ribbon} type="Detail" />}
            {villa?.ribbon && <Tag text={villa?.ribbon2} type="Detail" />}
          </div>
        </div>
      </div>
      <div className="flex items-center xsm:gap-3 gap-1.5">
        <h1 className="text-2xl font-medium leading-normal text-themeBlack">
          {villa.baslik}
        </h1>
        <FavoriteButton data={villa} borderStyle="border border-[#EDF2F7]">
          <Image
            src={"/icons/card-heart.svg"}
            alt="card-heart"
            width={14}
            height={14}
            className="object-contain"
          />
        </FavoriteButton>
        <Rating rating={villa.rating} reviews={villa.reviews} />
      </div>
      <Amenities
        beds={villa.yatak_odasi}
        bathrooms={villa.banyo}
        capacity={villa.kisi}
      />
    </div>
  );
};

export default DetailHeader;
